export const getAlignStyles = (isMobile = false) => (isMobile ? 'text-left' : 'text-center');
//# sourceMappingURL=getAlignStyles.js.map